export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-4-14d8e6742531c9237fa60220e32273a3.jpg";